/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('MyGroupCtrl', function($scope, $window, $timeout, $routeParams, $uibModal, Activity, ErrorThrower) {
    //permet de définir si la personne est adm ou pas.
    //On part du principe que si la personne a un rôle student
    //elle doit pouvoir créer un groupe sans problème.
    const isADM = function() {
        let needle;
        if (($scope.me == null)) { return false; }

        switch (false) {
            case (needle = -1, [$scope.me.groups.indexOf('adm'), $scope.me.groups.indexOf('student')].includes(needle)): return false;
            case -1 !== !$scope.me.groups.indexOf('adm'): return true;
            default: return false;
        }
    };

    const errorManager                = new ErrorThrower;
    $scope.inviteShow           = false;
    $scope.waiting              = undefined;
    $scope.mygroup_collapse     = true;
    $scope.newMember            = { };
    $scope.title                = 'Mon groupe';
    $scope.content              = '';
    $scope.isADM                = isADM();
    let valid_invitation            = 1;
    const {
        project
    } = $scope;
    $scope.group_loading        = true;

    $scope.profs
    .then(function(profs_list) {
        const profs_logins        = profs_list.map(prof => prof.login);
        return $scope.profOnThisUv = -1 !== profs_logins.indexOf($scope.me.login);}).finally(function() {
        // par défaut on affiche le contenu de my groupe
        $scope.mygroup_collapse = false;
        if ($scope.profOnThisUv || $scope.isADM) {
            $scope.title = 'Groupes';
            // Pour un prof on veux collapse le widget par défaut
            $scope.mygroup_collapse = true;
        }
        $scope.groups = Activity.groups($routeParams);
        if (!$scope.profOnThisUv) { return init(); }
    });

    $scope.reloadUnsubscribed = () => $scope.$emit('reloadUnsubscribed');

    var init = function() {
        $scope.subscribe_over = false;
        if ($scope.project.registration_date != null) {
            $scope.subscribe_over = moment().isAfter(moment($scope.project.registration_date));
        }

        return Activity
        .mygroup($routeParams)
        .$promise
        .then(function(mygroup) {
            $scope.group          = mygroup;
            $routeParams.group_id = mygroup.id;
            return setAdvice(mygroup);}).catch(function(error) {
            if (error.status !== 404) {
                return errorManager.minor(error.data);
            }}).finally(() => $scope.group_loading = false);
    };

    var setAdvice = function(group) {
        $scope.advice  = false;
        const group_length   = group.members.length;
        $scope.waiting = group.members.filter(function(member) {
            valid_invitation *= member.validation;
            return ($scope.me.login === member.login) && (0 === member.validation);
        });
        switch (false) {
            case (1 === valid_invitation) || !(project.min_student <= group_length) || !!$scope.waiting.length:
                $scope.advice = {
                    content:
                        `\
Attention, certains membres de votre groupe n'ont pas accepté votre invitation.
Si votre groupe n'est pas complet à la date butoir, il sera dissous.\
`,
                    type: 'alert-warning'
                };
                break;
            case !($scope.project.min_student > $scope.group.members.length):
                $scope.advice = {
                    content:
                        `\
Attention ! votre groupe n'est pas complet.
Si votre groupe n'est pas complet à la date butoir, il sera dissous.\
`,
                    type: 'alert-danger'
                };
                break;
        }
        return $scope.initInfo();
    };

    $scope.ejectInfo = function(member) {
        const valid           = 1 === member.validation ? 'oui' : 'non';
        $scope.content  = `Supprimer ce membre du groupe.<br/>prénom: ${member.firstname}<br/> `;
        return $scope.content += `nom: ${member.lastname}<br/> invitation acceptée: ${valid}<br/>`;
    };

    $scope.deleteInfo = () => $scope.content = 'Détruire votre groupe.';

    $scope.initInfo = () => $scope.content = 'Passez la souris sur une icône pour obtenir des détails';

    $scope.changeNewMember = login => $scope.newMember.login = login;

    $scope.createGroup = function() {
        $scope.group_loading  = true;
        return Activity
        .saveGroup($routeParams)
        .$promise
        .then(function(new_group) {
            $routeParams.group_id = new_group.id;
            return $scope.group          = new_group;}).catch(error => errorManager.minor(error.data)).finally(() => $scope.group_loading  = false);
    };

    $scope.deleteGroup = () => $timeout(function() { // pour ne pas être dérangé par le mouseleave
        if ($window.confirm('Ceci va détruire votre groupe, êtes vous sur ?')) {
            $scope.group_loading = true;

            return Activity
            .deleteGroup($routeParams)
            .$promise
            .then(() => $scope.group = null).catch(function(error) {
                errorManager.minor(error.data);
                return $scope.initInfo();}).finally(() => $scope.group_loading = false);
        }
    });

    $scope.deleteMember = member => $timeout(function() {
        if ($window.confirm(`Éjecter ${member.login} du groupe, êtes vous sur ?`)) {
            $scope.group_loading = true;

            const promise = Activity.deleteMemberGroup($routeParams, { student: member.login }).$promise;
            promise.then(function(updated_group) {
                $scope.group       = updated_group;

                $scope.reloadUnsubscribed();

                return setAdvice(updated_group);
            });
            promise.catch(error => errorManager.minor(error.data));
            promise.finally(() => $scope.group_loading = false);
            return $scope.initInfo();
        }
    });

    $scope.addMember = function() {
        if (!$scope.newMember) { return; }
        const student = $scope.unsubscribed.filter(unsubscribed => unsubscribed.login === $scope.newMember.login);
        if (0 === student.length) {
            errorManager.minor('L\'étudiant n\'existe pas ou appartient déjà à un groupe.');
            return;
        }

        $scope.group_loading = true;

        return Activity
        .addMemberGroup($routeParams, { student: $scope.newMember.login })
        .$promise
        .then(function(updated_group) {
            $scope.group          = updated_group;
            $scope.unsubscribed   = $scope.unsubscribed.filter(unsubscribed => unsubscribed.login !== $scope.newMember.login);
            $scope.newMember.login = '';
            return setAdvice(updated_group);}).catch(error => errorManager.minor(error.data)).finally(() => $scope.group_loading = false);
    };

    $scope.groupValidation = function(response) {
        $scope.group_loading = true;

        return Activity
        .validationGroup($routeParams, { validation: response })
        .$promise
        .then(function(valid_group) {
            $scope.waiting = undefined;
            return $scope.group   = valid_group;}).catch(error => errorManager.minor(error.data)).finally(() => $scope.group_loading = false);
    };

    $scope.mygroupCollapse = () => $scope.mygroup_collapse = $scope.mygroup_collapse ? false : true;

    // Afficher tous les groupes avec la modal
    return $scope.openModal = function() {
        const modalInstance = $uibModal.open({
            templateUrl: 'directives/widget/mygroup/modal_template.html',
            controller:  'ModalGroupListCtrl',
            resolve: {
                groups() { return $scope.groups; }
            }
        });

        return modalInstance;
    };
});
